import { Action } from '@/_core/fluxstore/types';
import { StorymapState } from '../types';
import { useStorymapStore } from '../useModule';
import { Effort } from '../../api/queries';

const { registerReducer } = useStorymapStore();

export class ChangeEffortFilter extends Action<StorymapState> {
    public static ACTION_TYPE = 'ChangeEffortFilter';

    public constructor(public effort: Effort) {
        super(ChangeEffortFilter.ACTION_TYPE);
    }
}

const reducer = (state: StorymapState, action: ChangeEffortFilter): void => {
    if (state.filterState.efforts.includes(action.effort)) {
        state.filterState.efforts = state.filterState.efforts.filter(x => x != action.effort);
    }
    else {
        state.filterState.efforts.push(action.effort);
    }
};

//@ts-ignore
registerReducer(ChangeEffortFilter.ACTION_TYPE, reducer);